module.exports = __webpack_public_path__ + "static/media/Leopard size comparison.392f9964.png";